import { createStore } from "vuex";

export default createStore({
  state: {},
  mutations: {
    setLoginUser(state, data) {
      state.loginUser = data;
      localStorage.setItem("phone", data.phone);
    },
    setLoading(state, data) {
      state.loadingData = data;
    },
  },
  actions: {},
  modules: {},
});
